'use client';

import { ChevronRight } from 'lucide-react';

import Link from 'next/link';

import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/Heading';
import { MenuItem } from '@/core/types/menuApi';
import { useDrawerStore } from '@/stores/drawerStore';
import HeaderProfileLogin from './HeaderProfileLogin';
import HeaderSelecetLanguage from './HeaderSelecetLanguage';
import { normalizeLink } from '@/core/lib/utils';
type SidebarMenuProps = {
  mainItems: MenuItem[];
};

export default function PrimaryDrawer({
  mainItems,
}: SidebarMenuProps) {
  const { primaryOpen, setPrimaryOpen, setSecondaryOpen, setSelectedItemId } =
    useDrawerStore();

  function handleClose() {
    setPrimaryOpen(false);
    setSecondaryOpen(false);
  }

  function handleItemClick(id: number) {
    setSelectedItemId(id);
    setSecondaryOpen(true);
  }


  return (
    <div
      className={`transition-transform no-scrollbar duration-300 ease-in-out bg-white overflow-y-auto pointer-events-auto fixed top-18 h-full z-50 lg:z-70 ${primaryOpen
        ? 'translate-x-0 w-full lg:w-80 ltr:border-r rtl:border-l'
        : 'ltr:-translate-x-full rtl:translate-x-full w-0 lg:w-80'
        } ltr:left-0 rtl:right-0`}
      role="navigation"
      aria-label="Primary navigation drawer"
    >
      <div className="min-h-[91%] flex flex-col">
        {/* Main items */}
        <div className="flex flex-col flex-1 p-4 ">
          {mainItems.length > 0 && (
            <ul className="flex flex-col gap-y-1">
              {mainItems.map(item => (
                <li
                  key={item.id}
                  className="group relative"
                  onMouseEnter={() => {
                    if (
                      window.innerWidth >= 1024 &&
                      item.children?.length > 0
                    ) {
                      handleItemClick(item.id);
                    }
                  }}
                >
                  <div className="flex items-center justify-between cursor-pointer min-h-13 p-2">

                    {/* اگر child داشت → div ساده بدون لینک */}
                    {item.children && item.children.length > 0 ? (
                      <div
                        className="flex-1"
                        onClick={() => handleItemClick(item.id)}
                      >
                        <Heading level={3} className="text-xs">{item.title}</Heading>
                      </div>
                    ) : (
                      /* اگر child نداشت → لینک واقعی */
                      <Link
                        href={normalizeLink(item.link) || "#"}
                        className="flex-1"
                        onClick={() => handleClose()}
                      >
                        <Heading level={3} className="text-xs">{item.title}</Heading>
                      </Link>
                    )}

                    {/* آیکن باز کردن submenu */}
                    {item.children && item.children.length > 0 && (
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleItemClick(item.id)}
                        aria-label={`Open submenu for ${item.title}`}
                        aria-expanded={
                          useDrawerStore.getState().secondaryOpen &&
                          useDrawerStore.getState().selectedItemId === item.id
                        }
                      >
                        <ChevronRight className="w-4 h-4 rtl:rotate-180" />
                      </Button>
                    )}
                  </div>

                </li>
              ))}
            </ul>
          )}
        </div>

        <div className='p-4 gap-4 flex justify-between items-center border-t border-secondary-100 pt-4'>
          <HeaderProfileLogin />
          <HeaderSelecetLanguage />
        </div>
      </div>
    </div>
  );
}
